var topMenuElement;
export var getTopMenuElement = function () {
    return topMenuElement || (topMenuElement = document.querySelector('.top-menu'));
};
